<template>
  <v-container class="w-auto mx-15" fluid>
    <v-row align="start" justify="center" class="d-flex align-self-start w-100">
      <v-col>
        <v-row class="grid-action-bar">
          <v-col class="px-0">
            <v-card-title class="pa-0">
              <v-text-field
                  class="quick-search pa-1"
                  v-on:keyup.enter="tableModel.quickSearch(quickSearchText)"
                  v-model="quickSearchText"
                  prepend-inner-icon="mdi-magnify"
                  :label="$t('Поиск')"
                  single-line
                  hide-details
                  variant="solo"
              ></v-text-field>
            </v-card-title>
          </v-col>

          <v-col class="actions-menu pr-0">
            <v-card-title class="pa-0" style="max-height: 60px">
              <v-btn color="primary" @click="tableModel.quickSearch(quickSearchText)">
                <v-icon icon="mdi-magnify"></v-icon>{{ $t('Найти') }}</v-btn>
            </v-card-title>
            <v-card-title class="pr-0 py-0 ml-auto">
              <v-btn color="primary" @click="create()">{{ $t('Добавить') }}</v-btn>
            </v-card-title>
          </v-col>
        </v-row>

        <DataTableGrid
            :items="items"
            :table-model="tableModel"
            :edit="edit"
            :switchStatus="switchStatus"
            :regenerate="regenerate"
        >
          <template v-slot:item.is_active="{ value }">
            <eventStatus
                :isSuccess="statusHelper.getStatus(value)"
                :value="statusHelper.getStatusLabel(value)"
            />
          </template>
        </DataTableGrid>
      </v-col>
    </v-row>
  </v-container>

  <ConfirmDialog ref="switchStatusDlg"/>
  <ConfirmDialog ref="regenerateDlg"/>
  <SaveFormDlg ref="editDlg" />
</template>

<script>
import api from '@/api';
import { toast } from '@/lib/toast';
import RemoteTableModel from '@/components/RemoteTableModel';
import DataTableGrid from "@/components/apiToken/DataTableGrid.vue";
import eventStatus from "@/components/eventStatus.vue";
import ConfirmDialog from "@intec/vue-components/form/ConfirmDialog.vue";
import SaveFormDlg from '@/components/apiToken/dialogs/SaveFormDlg.vue';
import { useApiIntegrationComponentStore } from '@/stores/apiIntegrationComponentStore.js';

export default {
  components: { eventStatus, DataTableGrid, ConfirmDialog, SaveFormDlg },
  data() {
    const { getColumnsHeaders } = useApiIntegrationComponentStore();
    const headers = getColumnsHeaders();

    let tableModel = new RemoteTableModel({
      headers: headers,
      loader(query) {
        return api.get('/vocab/api-tokens', {query: JSON.stringify(query)});
      },
      options: {
        itemsPerPage: 15
      }
    });
    return {
      tableModel: tableModel,
      items: headers.filter(header => !!header.title).map(header => header.key),
      quickSearchText: '',
      options: {},
      page: 1,
      pageCount: 0,
      pageSizes: [
        { title: '15', value: 15 },
        { title: '25', value: 25 },
        { title: '50', value: 50 },
        { title: '100', value: 100 },
      ],
      totalEntries: -1,
      statusHelper: {
        getStatusLabel: (value) => {
          return value === true ? 'Активен' : 'Заблокирован'
        },
        getStatus: (value) => {
          return !!value
        }
      }
    };
  },
  methods: {
    reload() {
      this.tableModel.reload();
    },
    async create() {
      let resultDialog = await this.$refs.editDlg.open(
          'create',
      );

      if (!resultDialog || !resultDialog?.value) {
        return;
      }

      try {
        let formData = new FormData();
        formData.append('data', JSON.stringify(resultDialog.value));

        await api.post(`/vocab/api-tokens`, formData);
        this.reload();
      } catch (e) {
        toast.error(e.message);
      }
    },
    async edit(item) {
      let resultDialog = await this.$refs.editDlg.open(
          'save',
          item
      );

      if (!resultDialog || !resultDialog?.value) {
        return;
      }

      try {
        const { id } = item;

        let formData = new FormData();
        formData.append('data', JSON.stringify(resultDialog.value));

        await api.post(`/vocab/api-tokens/${id}`, formData);
        this.reload();
      } catch (e) {
        toast.error(e.message);
      }
    },
    async regenerate(item) {
      let resultDialog = await this.$refs.regenerateDlg.open(
          'Сгенерировать новый токен',
          `Вы действительно хотите сгенерировать новый токен для сервиса ${item.name}?`
      );

      if (!resultDialog) {
        return;
      }

      const { id } = item;

      try {
        await api.get(`/vocab/api-tokens/${id}/regenerateToken`);
        this.reload();
      } catch (e) {
        toast.error(e.message);
      }
    },
    async switchStatus(item, mode) {
      const { id } = item;
      let resultDialog = true;

      if (mode === 'blocked') {
        resultDialog = await this.$refs.switchStatusDlg.open(
            'Блокирование доступа к API',
            `Вы действительно хотите заблокировать доступ к API для сервиса ${item.name}?`,
        );
      } else if (mode === 'unblocked') {
        resultDialog = await this.$refs.switchStatusDlg.open(
            'Разблокирование доступа к API',
            `Вы действительно хотите разблокировать доступ к API для сервиса ${item.name}?`,
        );
      }

      if (resultDialog) {
        try {
          await api.get(`/vocab/api-tokens/${id}/switchStatus`, {'mode': mode});
          this.reload();
        } catch (e) {
          toast.error(e.message);
        }
      }
    },
    filterGrid() {
      this.tableModel.reload();
    }
  },
  created() {
    this.filterGrid();
  },
};
</script>

<style lang="scss" scoped>
:deep(.v-data-table__td:nth-child(3), th:nth-child(3)) {
  color: rgb(var(--data-table-font-color));
}

:deep(.v-input) {
  background-color: rgb(var(--white-color));
  border: 1px solid rgb(var(--grey-border-color));
  border-radius: 8px;
}

:deep(.v-field) {
  padding: 0;
  font-family: Abrade;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  box-shadow: none;
}

:deep(.v-field__input) {
  display: block;
  padding: 0;
  width: 48px;
  height: 34px;
  min-height: 0;
}

.grid-action-bar {
  display: grid;
  grid-template-columns: 52.9% 47.1%
}

.actions-menu {
  display: flex;
  align-items: center;
  line-height: 44px;
  margin-bottom: 1px;
}

.quick-search {
  min-height: 44px;
  background-color: rgb(var(--white-color));
  border: 1px solid rgb(var(--border-color)) !important;
  border-radius: 8px;
}

:deep(.v-field__prepend-inner) {
  padding-left: 5px;
}

.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;

  :deep(.v-field__input) {
    display: block;
    padding: 0;
    width: 48px;
    height: 34px;
    min-height: 0;
    text-align: center;
    align-content: center;
  }
}

.page-size-select {
  width: 186px !important;
  background-color: rgb(var(--white-color));
  border: 1px solid rgb(var(--grey-border-color));
  border-radius: 8px;
}

.footer-font {
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
}
</style>
